import { formatDate } from '@/shared/lib'

/**
 * 차량 모델 정보를 기반으로 내 차 등록 요청 데이터를 포맷팅하는 함수
 *
 * @param socialId - 사용자 소셜 ID
 * @param brand - 차량 브랜드명
 * @param detailModel - 상세 모델명
 * @param standardId - 표준 ID (상세 모델 ID)
 * @param fuelTypeValue - 연료 타입 값
 * @param modelYear - 출고 연식 4자리 (미입력 시 등록 시점)
 * @param displacement - 배기량 cc (미입력 시 0)
 *
 * @returns 모델로 내 차 등록에 필요한 요청 데이터 객체
 */

interface IFormatRequestCreateMyCarByModelProps {
  socialId?: string | null
  brand?: string | null
  detailModel?: string | null
  standardId?: number | null
  fuelTypeValue?: string | null
  modelYear?: string | null
  displacement?: string | null
}

export const formatRequestCreateMyCarByModel = ({
  socialId,
  brand,
  detailModel,
  standardId,
  fuelTypeValue,
  modelYear,
  displacement,
}: IFormatRequestCreateMyCarByModelProps) => {
  return {
    // 사용자 정보
    socialId: socialId ?? '',
    nick: '',

    // 차량 기본 정보
    company: brand ?? '',
    name: detailModel ?? '',
    // 연식만 받으므로 월은 01 로 고정한다 (정산은 연도만 쓴다)
    birthday: modelYear ? `${modelYear}.01` : formatDate('YYYY.MM'),
    photo: '',

    // 차량 상세 스펙
    staple: fuelTypeValue ?? '0',
    gear: '0',
    level: '0',
    tank: '0',
    type: '0',
    number: '',
    grade: ' ',
    cc: displacement ?? '0',
    kpl: '0.0',
    fuel_unit: 'L',
    distance_unit: 'km',
    efficiency_unit: '0',
    tire_f: '',
    tire_r: '',

    // 기준 정보
    base_date: formatDate('YYYY.MM.DD'),
    base_distance: '0',
    memo: '',

    // 시스템 정보
    customYn: '',
    standardId: standardId?.toString() ?? '',
    serverId: '',
  }
}
